import {
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import PrimaryButton from "../PrimaryButton";
import { User } from "../../types/user.types";
import { useState } from "react";
import { useMutation } from "react-query";
import { sendInvitations } from "../../mutations/center.mutations";
import AddUserIcon from "../icons/AddUserIcon";
import { useCentersStore } from "../../stores/centers.store";

type InvitationSentModalProps = {
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function InvitationSentModal({ isOpen, onClose }: InvitationSentModalProps) {
	const [users] = useState<Partial<User>[]>([]);
	const { center } = useCentersStore();
	const { mutate: mutateSendInvitations } = useMutation(sendInvitations);

	const handleSendInvitation = () => {
		if (center) {
			mutateSendInvitations(
				{ center, users },
				{
					onSuccess: () => {
						onClose();
					},
				},
			);
		}
	};
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="30vw">
				<ModalHeader>
					<AddUserIcon w="48px" h="48px" mr="8px"></AddUserIcon>
					Invitations envoyées
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalBody></ModalBody>
				<ModalFooter borderTop="solid 1px #E2E8F0">
					<PrimaryButton onClick={handleSendInvitation}>
						Commencer
					</PrimaryButton>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
}

export default InvitationSentModal;
